import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { Router, Route } from "react-router-dom";
import { createBrowserHistory } from "history";

import "./index.css";

const history = createBrowserHistory();
const root = document.getElementById("root");

ReactDOM.render(
  <Router history={history}>
    <Route path="/" component={App} />
  </Router>,
  root
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js